export const Server = 'https://softtechhub.sbtstudentshop.ch/backend/public'

// export const Server = 'http://localhost:8000'